// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1JgoP","activeItem":"Pagination_activeItem__sX_IR","nextArrowIcon":"Pagination_nextArrowIcon__2uY78"};